module.exports = __webpack_public_path__ + "static/media/Lars.57273d53.jpg";